import React, { useEffect, useState } from 'react';
import PageTitle from '../Components/PageTitle';
import AxiosApi from '../Helper/axios.api';
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import { logout } from "../Action/Auth.action";

function copyToClipboard(ev, text, ogText=null) {
  navigator.clipboard.writeText(text);

  // change its value to "copied"
  ev.target.innerText = "copied to clipboard!"

  // after 1s set it back to text
  setTimeout(function () {
    ev.target.innerText = ogText || text;
  }, 1000)
}

const formatDuration = (duration) => {
  const minutes = duration%60, hours = Math.floor(duration / 60);
  return (
    hours > 0 ? ( `${hours} ` + (hours == 1 ? 'hour' : 'hours') ) : ''
  ) + (
    (minutes > 0 && hours > 0) ? ' and ' : ''
  ) + (
    minutes > 0 ? ( `${minutes} ` + (minutes == 1 ? 'minute' : 'minutes') ) : ''
  )
}

const formatTimeDelta = (diff) => {
  let minutes = Math.floor(diff/1000/60);
  let days = Math.floor(minutes / 60 / 24);
  minutes -= days * 60*24;
  let hours = Math.floor(minutes / 60);
  minutes -= hours * 60;

  let out = '';
  if (days > 0) out += `${days} ` + (days == 1 ? 'day' : 'days' );
  if (hours > 0) {
    if(out.length) out += minutes > 0 ? ', ' : ' and '
    out += `${hours} ` + ( hours == 1 ? 'hour' : 'hours' );
  }
  if (minutes > 0) {
    if(out.length) out += ' and '
    out += `${minutes} ` + ( minutes == 1 ? 'minute' : 'minutes' );
  }

  return out;
}

const formatStatus = (reservation, now) => {
  const time_start = new Date(reservation.time_start);
  const time_end = new Date(reservation.time_end);
  return (
    time_start > now ? (
      'Starts in '+formatTimeDelta(time_start - now)
    ) : time_end > now ? (
      'Ends in '+formatTimeDelta(time_end - now)
    ) : (
      'Ended '+formatTimeDelta(now - time_end)+' ago'
    )
  )
}

const RecentReservations = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState(null);
  const fetchData = async () => {
    try {
      const response = await AxiosApi.withToken(auth.accessToken, "admin/recent_reservations", "post", {user_id:auth.userDeatils.user_id});

      if (response.status) setData(response.data);
      else if (response.login === false) {
        dispatch(logout());
        navigate("/login");
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const now = new Date();

  return (
    <>
      <PageTitle title="DeepTherapy | Recent Reservations" />
      <div className="virtualization">
        <div className="card w-100">
          <div className="card-body">
            {data && (
              <>
              <p><i>Last update: {(new Date()).toLocaleString()}</i></p>
              <h2>Upcomming Reservations</h2>
              <ul>
                { data.upcomming.length > 0 ? (
                  data.upcomming.map((reservation,index) => (
                    <li key={index}>
                      <p>
                        By <b>{reservation.user_name}</b> {}
                        starting at <b>{(new Date(reservation.time_start)).toLocaleString("en-GB")}</b> {}
                        for <b>{formatDuration(reservation.duration)}</b>. {}
                        <i>{formatStatus(reservation, now)}.</i>
                        <br />
                        <strong>ID:</strong> <code onClick={(e) => copyToClipboard(e, reservation.id)}>{reservation.id}</code> | <Link to={'/reservation/'+reservation.id}>Open</Link>
                      </p>
                    </li>
                  ))
                ) : (
                  <i>No upcomming sessions.</i>
                )}
              </ul>
              <h2>Past Reservations (up to 100 days)</h2>
              <ul>
                { Object.entries(data.past_grouped).map(([username,reservations]) => (
                  <li key={username}>
                    <b>{username}</b>
                    <ul>{reservations.map((reservation,index) => (
                      <li key={index} title={reservation.id}>
                        Started <b>{new Date(reservation.time_start).toLocaleString("en-GB")}</b> {}
                        for <b>{formatDuration(reservation.duration)}</b>. <code onClick={(e) => copyToClipboard(e, reservation.id, 'copy id')}>copy id</code>
                      </li>
                    ))}</ul>
                  </li>
                )) }
              </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default RecentReservations;
